// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor4 from '@/game/prefabs/World/Mentors/Mentor4';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level18 extends TilemapScene {
  constructor() {
    super('Level18');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // winter_biome_3
    const winter_biome_3 = this.add.tilemap('winter-biome-3');
    winter_biome_3.addTilesetImage(
      'winter forest wang tiles (snowy)',
      'winter forest wang tiles (snowy)',
    );
    winter_biome_3.addTilesetImage(
      'winter forest (snowy)',
      'winter forest (snowy)',
    );
    winter_biome_3.addTilesetImage(
      'winter trees (snowy) 80x112',
      'winter trees (snowy) 80x112',
    );
    winter_biome_3.addTilesetImage('collision', 'collision & alpha');
    winter_biome_3.addTilesetImage(
      'winter water sparkles B 16x16',
      'summer water sparkles B 16x16',
    );

    // terrain_1
    winter_biome_3.createLayer(
      'terrain',
      ['winter forest wang tiles (snowy)'],
      0,
      0,
    );

    // water_sparkles_1
    winter_biome_3.createLayer(
      'water sparkles',
      ['winter water sparkles B 16x16'],
      0,
      0,
    );

    // deco
    winter_biome_3.createLayer('deco 1', ['winter forest (snowy)'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = winter_biome_3.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 520, 40);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 176, 232);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 472, 224);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 576, 112);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 776, 320);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 688, 480);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 240, 512);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 728, 488);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 704, 64, 'winter (snowy) 32x', 2);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 16, 304, 'winter (snowy) 32x', 2);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      640,
      256,
      'winter (snowy) 32x',
      2,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      704,
      576,
      'winter (snowy) 32x',
      2,
    );
    this.add.existing(forestTree_2);

    // mentor
    const mentor = new Mentor4(this, 464, 72);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 424, 488);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 272, 136);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 424, 288);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 624, 432);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 17;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 17;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 17;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 17;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 17;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 17;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 17;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 17;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 17;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 17;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.winter_biome_3 = winter_biome_3;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor4;
  private winter_biome_3!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.winter_biome_3,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
